<div [style]="'width:' + width +';height:' + height + ';'" class="flag" [class]="'flag--' + lang">
  <img [src]="'./assets/img/flags/' + lang?.toUpperCase() + '.svg'" [alt]="lang">
</div>
